// extracted by mini-css-extract-plugin
export default {"card":"Card_card__T-iLG","icon":"Card_icon__Ln+uS","iconWrapper":"Card_iconWrapper__Pf3mo","title":"Card_title__NurKI","p":"Card_p__eDQDb"};